import { useEffect, useRef, useState } from "react";

export default function useQuestionTiming(
  questions,
  currentIndex,
  initialTimes = {}
) {
  const [questionTimes, setQuestionTimes] = useState(initialTimes);
  const startRef = useRef(null);

  useEffect(() => {
    if (!questions[currentIndex]) return;

    startRef.current = Date.now();

    return () => {
      const elapsed = Math.round(
        (Date.now() - startRef.current) / 1000
      );

      const qid = questions[currentIndex].id;

      setQuestionTimes((prev) => ({
        ...prev,
        [qid]: (prev[qid] ?? 0) + elapsed,
      }));
    };
  }, [currentIndex, questions]);

  return { questionTimes, setQuestionTimes };
}
